// redux/dashboard/dashboardSelector.js

export const selectClientStatusData = (state) => state.dashboard.clientStatusData;
export const selectQueryTypeData = (state) => state.dashboard.queryTypeData;
export const selectSummaryData = (state) => state.dashboard.summaryData;
export const selectUserStatusData = (state) => state.dashboard.userStatusData;

// FIXED: Pointing to the correct object in state
export const selectQueriesCountAndProductivityData = (state) => state.dashboard.queriesCountAndProductivityData;

// Global Status for the dashboard
export const selectDashboardStatus = (state) => state.dashboard.status;
export const selectDashboardError = (state) => state.dashboard.error;
export const selectWorkingHoursData = (state) => state.dashboard.workingHoursData;
export const selectClockInData = (state) => state.dashboard.clockInData;
export const selectClockOutData = (state) => state.dashboard.clockOutData;
export const selectAttendanceDashboardData = (state) => state.dashboard.attendanceDashboardData;
export const selectClockStatus = (state) => state.dashboard.clockStatus;
export const selectClockStatusLoading = (state) => state.dashboard.clockStatusLoading;
export const selectclockStatusError = (state) => state.dashboard.clockStatusError;

export const selectActiveTasks = (state) => state.dashboard.activeTasks;
export const selectActiveTasksStatus = (state) =>
  state.dashboard.activeTasksStatus;
